
const AccessInfo = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(137,181,107,0.08)] overflow-hidden">
          {/* 所在地 */}
          <div className="flex flex-col md:flex-row border-b border-gray-100">
            <div className="md:w-[200px] flex-shrink-0 bg-[#F8FBF6] px-6 py-5 flex items-start">
              <span className="text-[13px] font-bold text-[#89B56B]">所在地</span>
            </div>
            <div className="flex-1 px-6 py-5">
              <p className="text-[13px] text-gray-700 leading-relaxed">〒141-0031</p>
              <p className="text-[13px] text-gray-700 leading-relaxed">東京都品川区西五反田8丁目7-11</p>
              <p className="text-[13px] text-gray-700 leading-relaxed">アクシス五反田ビル 7階</p>
            </div>
          </div>

          {/* 最寄り駅 */}
          <div className="flex flex-col md:flex-row border-b border-gray-100">
            <div className="md:w-[200px] flex-shrink-0 bg-[#F8FBF6] px-6 py-5 flex items-start">
              <span className="text-[13px] font-bold text-[#89B56B]">最寄り駅</span>
            </div>
            <div className="flex-1 px-6 py-5">
              <p className="text-[13px] text-gray-700 leading-relaxed">JR山手線 / 五反田駅 徒歩6分</p>
              <p className="text-[13px] text-gray-700 leading-relaxed">東急池上線 / 大崎広小路駅 徒歩3分</p>
            </div>
          </div>

          {/* 電話番号 */}
          <div className="flex flex-col md:flex-row border-b border-gray-100">
            <div className="md:w-[200px] flex-shrink-0 bg-[#F8FBF6] px-6 py-5 flex items-start">
              <span className="text-[13px] font-bold text-[#89B56B]">電話番号</span>
            </div>
            <div className="flex-1 px-6 py-5">
              <p className="text-[13px] text-gray-700 leading-relaxed">050-6877-5579</p>
            </div>
          </div>

          {/* FAX番号 */}
          <div className="flex flex-col md:flex-row">
            <div className="md:w-[200px] flex-shrink-0 bg-[#F8FBF6] px-6 py-5 flex items-start">
              <span className="text-[13px] font-bold text-[#89B56B]">FAX番号</span>
            </div>
            <div className="flex-1 px-6 py-5">
              <p className="text-[13px] text-gray-700 leading-relaxed">03-6869-3539</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccessInfo;
